import React from "react";
import { Link } from "react-router-dom";
import { useDocumentMeta } from "../components/useDocumentMeta";

function BookingConfirmed() {
  useDocumentMeta(
    "Meeting booked",
    "Your meeting with BoldBrave and Logikfabriken is confirmed.",
  );

  return (
    <section className="section">
      <div className="container booking-confirmed">
        <p className="kicker">You're all set</p>
        <h1 className="page-title">Your meeting is booked</h1>
        <p className="page-lead">
          Thanks — we've sent a calendar invitation to your inbox with the
          details. We're looking forward to talking platforms with you. If you
          need to reschedule, use the link in that invitation.
        </p>

        <div className="hero-cta-row">
          <Link className="cta-button" to="/work">
            Explore the track record
          </Link>
          <Link className="link-button-arrow" to="/">
            Back to home →
          </Link>
        </div>

        <p className="booking-confirmed-note">
          Something not right? Email us at{" "}
          <a href="mailto:magnus@bold-n-brave.com">magnus@bold-n-brave.com</a>.
        </p>
      </div>
    </section>
  );
}

export default BookingConfirmed;
